module.exports = __webpack_public_path__ + "media/bootstrap-icons/reception-2-b86be9f1.svg";